"use client"

import { useState } from "react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { Input } from "../../../components/ui/input"
import { Label } from "../../../components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select"
import { QrCode, Download, Copy, Link } from "lucide-react"

const predefinedPages = [
  { value: "/home", label: "Home Page" },
  { value: "/about", label: "About Us" },
  { value: "/services", label: "Services" },
  { value: "/contact", label: "Contact" },
  { value: "/donate", label: "Donation Page" },
  { value: "/events", label: "Events" },
  { value: "/prayer-request", label: "Prayer Request" },
]

// export function QRGeneratorSection({allUsers,adminUsers,allPages}:any) {
//   const [qrType, setQrType] = useState<"page" | "custom">("page")
//   const [selectedPage, setSelectedPage] = useState("")
//   const [customUrl, setCustomUrl] = useState("")
//   const [generatedQR, setGeneratedQR] = useState<string | null>(null)

//   const generateQR = () => {
//     const url = qrType === "page" ? `https://ministry.com${selectedPage}` : customUrl
//     if (!url) return

//     // In a real implementation, you would use a QR code library
//     // For demo purposes, we'll use a placeholder
//     const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(url)}`
//     setGeneratedQR(qrCodeUrl)
//   }

//   const downloadQR = () => {
//     if (generatedQR) {
//       const link = document.createElement("a")
//       link.href = generatedQR
//       link.download = "qr-code.png"
//       link.click()
//     }
//   }

//   const copyQRUrl = () => {
//     if (generatedQR) {
//       navigator.clipboard.writeText(generatedQR)
//     }
//   }

//   const isGenerateDisabled = qrType === "page" ? !selectedPage : !customUrl

//   return (
//     <div className="space-y-6">
//       <Card>
//         <CardHeader>
//           <CardTitle className="flex items-center gap-2">
//             <QrCode className="h-5 w-5" />
//             QR Code Generator
//           </CardTitle>
//           <CardDescription>Generate QR codes for any page or custom link</CardDescription>
//         </CardHeader>
//         <CardContent className="space-y-6">
//           <div className="grid gap-4 md:grid-cols-2">
//             <div className="space-y-4">
//               <div>
//                 <Label htmlFor="qr-type">QR Code Type</Label>
//                 <Select value={qrType} onValueChange={(value: "page" | "custom") => setQrType(value)}>
//                   <SelectTrigger>
//                     <SelectValue placeholder="Select QR type" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="page">Website Page</SelectItem>
//                     <SelectItem value="custom">Custom URL</SelectItem>
//                   </SelectContent>
//                 </Select>
//               </div>

//               {qrType === "page" ? (
//                 <div>
//                   <Label htmlFor="page-select">Select Page</Label>
//                   <Select value={selectedPage} onValueChange={setSelectedPage}>
//                     <SelectTrigger>
//                       <SelectValue placeholder="Choose a page" />
//                     </SelectTrigger>
//                     <SelectContent>
//                       {predefinedPages.map((page) => (
//                         <SelectItem key={page.value} value={page.value}>
//                           {page.label}
//                         </SelectItem>
//                       ))}
//                     </SelectContent>
//                   </Select>
//                 </div>
//               ) : (
//                 <div>
//                   <Label htmlFor="custom-url">Custom URL</Label>
//                   <Input
//                     id="custom-url"
//                     placeholder="https://example.com"
//                     value={customUrl}
//                     onChange={(e) => setCustomUrl(e.target.value)}
//                   />
//                 </div>
//               )}

//               <Button onClick={generateQR} disabled={isGenerateDisabled} className="w-full">
//                 <QrCode className="h-4 w-4 mr-2" />
//                 Generate QR Code
//               </Button>
//             </div>

//             <div className="flex flex-col items-center justify-center space-y-4">
//               {generatedQR ? (
//                 <>
//                   <div className="border rounded-lg p-4 bg-white">
//                     <img src={generatedQR || "/placeholder.svg"} alt="Generated QR Code" className="w-48 h-48" />
//                   </div>
//                   <div className="flex gap-2">
//                     <Button variant="outline" onClick={downloadQR}>
//                       <Download className="h-4 w-4 mr-2" />
//                       Download
//                     </Button>
//                     <Button variant="outline" onClick={copyQRUrl}>
//                       <Copy className="h-4 w-4 mr-2" />
//                       Copy URL
//                     </Button>
//                   </div>
//                 </>
//               ) : (
//                 <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
//                   <QrCode className="h-12 w-12 mx-auto text-muted-foreground/50 mb-2" />
//                   <p className="text-muted-foreground">QR code will appear here</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="border-t pt-4">
//             <h3 className="font-medium mb-2">Quick Links</h3>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
//               {predefinedPages.slice(0, 4).map((page) => (
//                 <Button
//                   key={page.value}
//                   variant="outline"
//                   size="sm"
//                   onClick={() => {
//                     setQrType("page")
//                     setSelectedPage(page.value)
//                   }}
//                 >
//                   <Link className="h-3 w-3 mr-1" />
//                   {page.label}
//                 </Button>
//               ))}
//             </div>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   )
// }


export function QRGeneratorSection({ allUsers, adminUsers, allPages }: any) {
  const [qrType, setQrType] = useState<"page" | "custom">("page")
  const [selectedPage, setSelectedPage] = useState("")
  const [customUrl, setCustomUrl] = useState("")
  const [generatedQR, setGeneratedQR] = useState<string | null>(null)

  const baseUrl = "https://tsoministries.com"

  const generateQR = () => {
    const url = qrType === "page" ? `${baseUrl}${selectedPage}` : customUrl
    if (!url) return

    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(url)}`
    setGeneratedQR(qrCodeUrl)
  }

  const downloadQR = () => {
    if (generatedQR) {
      const link = document.createElement("a")
      link.href = generatedQR
      link.download = "qr-code.png"
      link.click()
    }
  }

  const copyQRUrl = () => {
    if (generatedQR) {
      navigator.clipboard.writeText(generatedQR)
    }
  }

  const isGenerateDisabled = qrType === "page" ? !selectedPage : !customUrl

  // Convert allPages into { value, label } format
  const pageOptions = allPages.map((page: any) => ({
    value: new URL(page.link).pathname.replace(/\/$/, ""), // remove trailing slash
    label: page.title?.rendered || "(Untitled Page)"
  }))

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <QrCode className="h-5 w-5" />
            QR Code Generator
          </CardTitle>
          <CardDescription>Generate QR codes for any page or custom link</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid gap-4 md:grid-cols-2">
            <div className="space-y-4">
              <div>
                <Label htmlFor="qr-type">QR Code Type</Label>
                <Select value={qrType} onValueChange={(value: "page" | "custom") => setQrType(value)}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select QR type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="page">Website Page</SelectItem>
                    <SelectItem value="custom">Custom URL</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {qrType === "page" ? (
                <div>
                  <Label htmlFor="page-select">Select Page</Label>
                  <Select value={selectedPage} onValueChange={setSelectedPage}>
                    <SelectTrigger>
                      <SelectValue placeholder="Choose a page" />
                    </SelectTrigger>
                    <SelectContent>
                      {pageOptions.map((page:any) => (
                        <SelectItem key={page.value} value={page.value}>
                          {page.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              ) : (
                <div>
                  <Label htmlFor="custom-url">Custom URL</Label>
                  <Input
                    id="custom-url"
                    placeholder="https://example.com"
                    value={customUrl}
                    onChange={(e) => setCustomUrl(e.target.value)}
                  />
                </div>
              )}

              <Button onClick={generateQR} disabled={isGenerateDisabled} className="w-full">
                <QrCode className="h-4 w-4 mr-2" />
                Generate QR Code
              </Button>
            </div>

            <div className="flex flex-col items-center justify-center space-y-4">
              {generatedQR ? (
                <>
                  <div className="border rounded-lg p-4 bg-white">
                    <img src={generatedQR} alt="Generated QR Code" className="w-48 h-48" />
                  </div>
                  <div className="flex gap-2">
                    <Button variant="outline" onClick={downloadQR}>
                      <Download className="h-4 w-4 mr-2" />
                      Download
                    </Button>
                    <Button variant="outline" onClick={copyQRUrl}>
                      <Copy className="h-4 w-4 mr-2" />
                      Copy URL
                    </Button>
                  </div>
                </>
              ) : (
                <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
                  <QrCode className="h-12 w-12 mx-auto text-muted-foreground/50 mb-2" />
                  <p className="text-muted-foreground">QR code will appear here</p>
                </div>
              )}
            </div>
          </div>

          <div className="border-t pt-4">
            <h3 className="font-medium mb-2">Quick Links</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {pageOptions.slice(0, 4).map((page:any) => (
                <Button
                  key={page.value}
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    setQrType("page")
                    setSelectedPage(page.value)
                  }}
                >
                  <Link className="h-3 w-3 mr-1" />
                  {page.label}
                </Button>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
